import { StateField } from '@codemirror/state';
import { Decoration, EditorView } from '@codemirror/view';

const PLUGIN_TAG_REGEXP = /\[\[plugin:.*?\]\]/g;

const createDecorations = (doc) => {
  const decorations = [];
  const text = doc.toString();

  let match = PLUGIN_TAG_REGEXP.exec(text);

  while (match) {
    const start = match.index;
    const end = start + match[0].length;
    const range = Decoration.mark({ class: 'plugin-tag' }).range(start, end);

    decorations.push(range);

    match = PLUGIN_TAG_REGEXP.exec(text);
  }

  return Decoration.set(decorations);
};

export const pluginStyles = EditorView.baseTheme({
  '.plugin-tag': {
    backgroundColor: '#1fb77730',
    borderRadius: 'var(--border-radius-base)',
    color: 'var(--color-green-500)',
    padding: '1px 4px 3px'
  },
  '.cm-line .plugin-tag::selection': {
    backgroundColor: 'rgba(0,0,0,.15) !important',
    borderRadius: 'var(--border-radius-base)'
  }
});

export const pluginHighlighting = StateField.define({
  create(state) {
    return createDecorations(state.doc);
  },
  update(decorations, tr) {
    if (tr.docChanged) {
      return createDecorations(tr.newDoc);
    }

    return decorations;
  },
  provide: (f) => EditorView.decorations.from(f)
});
